import classNames from "classnames";

import SectionHeader from "./SectionHeader";
import styles from "./HowWeWork.module.css";

const HowWeWork = () => (
  <div className={styles.howWeWork}>
    <SectionHeader title="How we work" anchor="how-we-work">
      It’s important that you enjoy your job, and love your life outside of work.
    </SectionHeader>

    <div className={styles.wrapper}>
      <div className={styles.col}>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>
            Time for <em>actual</em> work
          </h3>
          <p className={styles.cardText}>
            We have one meeting with the entire team per week – that’s it. We work autonomously, communicate
            asynchronously and collaborate ad-hoc. Every week, we demo what we’ve accomplished.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={classNames(styles.cardTitle, styles.cardTitleRayday)}>
            Rayday
            <span className={styles.newOuter}>
              <span className={styles.newInner}>New in 2022</span>
            </span>
          </h3>
          <p className={styles.cardText}>
            Some of our most-loved features, such as Floating Notes, and tools like Ray.so have come from hackdays.
            That’s why Fridays are for hacking.
          </p>
          <p className={styles.cardText}>
            Take a step away from your team work for a day, and build whatever you like. Hack on a new extension,
            explore new design system components, or tidy up Notion. It’s up to you!
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Fast moving</h3>
          <p className={styles.cardText}>
            Our aim is to continue making the best product we can. We bias to action and shipped 37 releases in 2021,
            including big features such as our Extensions API and hundreds of bug fixes and improvements.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Modern tooling</h3>
          <p className={styles.cardText}>
            We surround ourselves with the best work tools available. Figma, Linear, Notion, Cron, you name it. This
            environment sets the standard for our software.
          </p>
        </div>
      </div>

      <div className={styles.col}>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Yearly meetups</h3>
          <p className={styles.cardText}>
            Once a year we bring the entire team together. In 2021, we rented a villa in Dubai where we launched our
            Extensions API, drove quad bikes in the desert and competed in top golf. We can’t wait to see where it takes
            us this year.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Work on something you use, and our users love</h3>
          <p className={styles.cardText}>
            All of us use Raycast every single day. We have internal extensions to write weekly updates, ship releases
            and more. It makes a huge difference if you build something that you actually use. Many features came out of
            our daily problems.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Fully distributed team</h3>
          <p className={styles.cardText}>
            We are a fully distributed company with 16 people, 3 dogs and 5 cats in 9 countries. Everybody works on the
            schedule that fits them best. It allows us to structure our work around our lives and not the other way
            around.
          </p>
          <p className={styles.cardText}>
            Want to work in a warm city during the winter? Go for it. If you’re at lunch or you’re taking your dog for a
            walk during the day, set your Slack status so the rest of your team knows about it.
          </p>
        </div>
      </div>

      <div className={styles.col}>
        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Cut out the s#!%</h3>
          <p className={styles.cardText}>
            Many of us left companies because bureaucracy killed product development. We are here to build a great
            product with like-minded people. Everything else doesn’t matter.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>We have fun</h3>
          <p className={styles.cardText}>
            It isn’t all work and no play. We get together regularly to play games, make pancakes or other virtual
            activities. Our #watercooler Slack channel is jammed with photos outside of work and weekend plans.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>We care about design</h3>
          <p className={styles.cardText}>
            Design is at the heart of the product and team. Every pixel and every detail matters.
          </p>
          <p className={styles.cardText}>
            From icons, to the UI in both dark and light mode, illustrations, social media content, it all belongs to
            the same story.
          </p>
        </div>

        <div className={styles.card}>
          <h3 className={styles.cardTitle}>Collaborate with a community</h3>
          <p className={styles.cardText}>
            Get direct feedback from passionate users, who actively contribute to the product with 600+ script commands
            and 200+ extensions, and work with the community to make Raycast even better.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default HowWeWork;
